module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/email-tracking-flow/check-sign.png"